import { render, staticRenderFns } from "./TheFeeWaiverForm.vue?vue&type=template&id=4927ba4f&scoped=true&"
import script from "./TheFeeWaiverForm.vue?vue&type=script&lang=js&"
export * from "./TheFeeWaiverForm.vue?vue&type=script&lang=js&"
import style0 from "./TheFeeWaiverForm.vue?vue&type=style&index=0&id=4927ba4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4927ba4f",
  null
  
)

export default component.exports